// Mock data for trademark services website

export const services = [
  {
    id: 'trademark-registration',
    title: 'Trademark Registration',
    shortDesc: 'Protect your brand identity with comprehensive trademark registration services.',
    icon: 'shield',
    features: ['Federal Registration', 'Comprehensive Search', 'Office Action Response', 'Certificate Delivery'],
    price: 'Starting at $599',
    slug: '/services/trademark-registration'
  },
  {
    id: 'copyright-registration',
    title: 'Copyright Registration',
    shortDesc: 'Secure your creative works with official copyright protection.',
    icon: 'file-text',
    features: ['Literary Works', 'Visual Arts', 'Music & Audio', 'Digital Content'],
    price: 'Starting at $399',
    slug: '/services/copyright-registration'
  },
  {
    id: 'company-formation',
    title: 'Company Formation',
    shortDesc: 'Establish your business entity with expert formation services.',
    icon: 'building',
    features: ['LLC Formation', 'Corporation Setup', 'EIN Registration', 'Compliance Support'],
    price: 'Starting at $299',
    slug: '/services/company-formation'
  },
  {
    id: 'trademark-search',
    title: 'Trademark Search',
    shortDesc: 'Comprehensive trademark availability search before filing.',
    icon: 'search',
    features: ['Federal Database', 'State Records', 'Common Law Search', 'Detailed Report'],
    price: 'Starting at $199',
    slug: '/services/trademark-search'
  },
  {
    id: 'amazon-brand-registry',
    title: 'Amazon Brand Registry',
    shortDesc: 'Enroll your brand in Amazon Brand Registry for enhanced protection.',
    icon: 'shopping-bag',
    features: ['Brand Enrollment', 'Content Control', 'Infringement Tools', 'Analytics Access'],
    price: 'Starting at $499',
    slug: '/services/amazon-brand-registry'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Alexandra Thompson',
    company: 'TechStart Inc.',
    role: 'CEO',
    content: 'The trademark registration process was seamless. Their team handled everything professionally and kept us informed at every step. Highly recommended!',
    rating: 5
  },
  {
    id: 2,
    name: 'Marcus Wellington',
    company: 'Creative Studios',
    role: 'Founder',
    content: 'Exceptional service! They helped us register multiple trademarks and provided invaluable guidance on brand protection strategies.',
    rating: 5
  },
  {
    id: 3,
    name: 'Priya Desai',
    company: 'Fashion Forward',
    role: 'Brand Director',
    content: 'Professional, efficient, and knowledgeable. They made the complex trademark process easy to understand and navigate.',
    rating: 5
  },
  {
    id: 4,
    name: 'James O\'Connor',
    company: 'Brew Masters Co.',
    role: 'Co-Founder',
    content: 'Working with this team was a game-changer for our business. They secured our trademark quickly and handled all the complexities with ease.',
    rating: 5
  },
  {
    id: 5,
    name: 'Yuki Tanaka',
    company: 'Digital Innovations',
    role: 'CEO',
    content: 'Outstanding expertise in trademark law. They not only registered our mark but also provided strategic advice that protected our entire product line.',
    rating: 5
  },
  {
    id: 6,
    name: 'Isabella Martinez',
    company: 'Lifestyle Brands LLC',
    role: 'Managing Partner',
    content: 'From start to finish, the experience was exceptional. Their attention to detail and commitment to our success made all the difference.',
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: 'How long does the trademark registration process take?',
    answer: 'The trademark registration process typically takes 8-12 months from filing to registration. However, you receive a filing date immediately upon submission, which establishes your priority rights.'
  },
  {
    id: 2,
    question: 'What is the difference between a trademark and a copyright?',
    answer: 'A trademark protects brand names, logos, and slogans that identify goods or services. A copyright protects original creative works like books, music, art, and software. Both offer different types of legal protection.'
  },
  {
    id: 3,
    question: 'Do I need to trademark my business name?',
    answer: 'If you want exclusive rights to use your business name nationwide and prevent others from using similar names in your industry, then yes. A trademark provides legal protection and helps build brand value.'
  },
  {
    id: 4,
    question: 'What happens if my trademark application is rejected?',
    answer: 'We handle office action responses as part of our service. If the USPTO raises concerns, we work with you to address them. Our experienced team has a high success rate in overcoming objections.'
  },
  {
    id: 5,
    question: 'Can I trademark a logo and business name separately?',
    answer: 'Yes, and we often recommend it. Registering them separately provides broader protection. If you rebrand your logo later, your business name trademark remains protected.'
  },
  {
    id: 6,
    question: 'What is included in a trademark search?',
    answer: 'Our comprehensive search includes federal trademark databases, state registrations, common law uses, domain names, and social media handles to assess potential conflicts before filing.'
  }
];

export const processSteps = [
  {
    step: 1,
    title: 'Consultation & Search',
    description: 'We discuss your needs, conduct a comprehensive trademark search, and assess registrability to identify any potential conflicts.'
  },
  {
    step: 2,
    title: 'Application & Filing',
    description: 'Our attorneys prepare and file your trademark application with the USPTO within 24-48 hours, ensuring accuracy and completeness.'
  },
  {
    step: 3,
    title: 'Monitoring & Registration',
    description: 'We monitor your application, handle any office actions, and deliver your official trademark registration certificate upon approval.'
  }
];

export const teamMembers = [
  {
    id: 1,
    name: 'David Martinez',
    role: 'Managing Attorney',
    bio: 'With over 15 years of experience in intellectual property law, David leads our trademark practice with expertise and dedication.',
    expertise: ['Trademark Law', 'IP Strategy', 'Litigation']
  },
  {
    id: 2,
    name: 'Jennifer Wong',
    role: 'Senior Trademark Specialist',
    bio: 'Jennifer has successfully registered over 2,000 trademarks and specializes in complex trademark prosecution.',
    expertise: ['Trademark Registration', 'Office Actions', 'Brand Strategy']
  },
  {
    id: 3,
    name: 'Robert Anderson',
    role: 'Copyright & IP Counsel',
    bio: 'Robert brings comprehensive knowledge in copyright law and digital IP protection to our clients.',
    expertise: ['Copyright Law', 'Digital Rights', 'Content Protection']
  }
];

export const stats = [
  { number: '5000+', label: 'Trademarks Registered' },
  { number: '98%', label: 'Success Rate' },
  { number: '15+', label: 'Years Experience' },
  { number: '24/7', label: 'Client Support' }
];

// Mock function to simulate contact form submission
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Form submitted (mock):', formData);
      resolve({ success: true, message: 'Thank you! We will contact you soon.' });
    }, 1000);
  });
};
